<template>
    <div class="order-handle-dialog-operate">
        <p class="tip">*这是基于样本（ID：{{sampleId}}）的第{{sampleRecollectTimes}}次重采</p>
        <pt-form-item label="是否需要重采费用:" label-width="130px" lineHeight="50">
            <el-radio-group v-model="form.radio2">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
            </el-radio-group>
        </pt-form-item>
        <pt-form-item label="重采费用:" label-width="130px" lineHeight="50" v-if="form.radio2">
            <el-input placeholder="请输入内容" v-model="form.sampleRecollectCost" class="input-with-select">
                <el-button slot="append">¥</el-button>
            </el-input>
        </pt-form-item>
    </div>
</template>

<script>
import { validate } from 'utils/validate'
export default {
  props: {
    sampleId: {
      type: String
    },
    value: {
      type: Object
    },
    sampleRecollectTimes: {
      type: Number
    }
  },
  data () {
    return {
      form: JSON.stringify(this.value) === '{}' ? {
        radio2: true,
        sampleRecollectCost: ''
      } : this.value
    }
  },
  watch: {
    form: {
      handler: function (val, oldVal) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  methods: {
    formValidate () {
      return validate(this, this.form)
    }
  }
}
</script>

<style lang="less">
.order-handle-dialog-operate{
    .tip{
        color:#8f8f8f;
    }
    .el-input-group{
        width:200px;
    }

    .form-item{
        padding: 50px 0;
    }
}

</style>
